import { render, staticRenderFns } from "./CurationDelete.vue?vue&type=template&id=2b86645c&scoped=true"
import script from "./CurationDelete.vue?vue&type=script&lang=js"
export * from "./CurationDelete.vue?vue&type=script&lang=js"
import style0 from "./CurationDelete.vue?vue&type=style&index=0&id=2b86645c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86645c",
  null
  
)

export default component.exports